export default __webpack_public_path__ + "static/media/pugjs.8e81a8ae.svg";